import { GET_INTERNSHIPS_TYPES } from "../../../../enums/Request/request.types";

export const getInternhipsTypeAction = (data) => {
    return {
        type: GET_INTERNSHIPS_TYPES,
        payload: data,
    };
};
